
const map = {}
let count = 0
let _nuxt_worker

function initWorker () {
  const worker = new Worker(new URL("/vercel/path0/app/workers/search.ts", import.meta.url), { type: 'module' })
  worker.onmessage = (e) => {
    const [resolve, reject] = map[e.data.id]
    if ('error' in e.data) {
      reject(new Error(e.data.error))
    } else {
      resolve(e.data.result)
    }
  }
  return worker
}

export async function warmupSearch (...args) {
  _nuxt_worker ||= initWorker()

  const id = count++
  return new Promise((resolve, reject) => {
    map[id] = [resolve, reject]
    _nuxt_worker.postMessage({ name: "warmupSearch", args, id })
  })
}

export async function searchContent (...args) {
  _nuxt_worker ||= initWorker()

  const id = count++
  return new Promise((resolve, reject) => {
    map[id] = [resolve, reject]
    _nuxt_worker.postMessage({ name: "searchContent", args, id })
  })
}
